export default __webpack_public_path__ + "static/media/KEB-Hana.6853c368.png";